import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Enum } from './../../utility/enum.enum';
import { IesHttpClient } from '../ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';
import { AppGlobals } from './../../Common/Services/app.global';
var SharedService = (function () {
    function SharedService(_http, _httpClient, appGlobal) {
        this._http = _http;
        this._httpClient = _httpClient;
        this.appGlobal = appGlobal;
    }
    SharedService.prototype.ngOnInit = function () {
    };
    Object.defineProperty(SharedService.prototype, "locationList", {
        get: function () {
            return this.locationData;
        },
        set: function (values) {
            this.locationData = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedService.prototype, "locationMappedWithBCenterList", {
        get: function () {
            return this.locationMappedWithBCenterData;
        },
        set: function (values) {
            this.locationMappedWithBCenterData = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedService.prototype, "keyboardTypeList", {
        get: function () {
            return this.keyboardTypeData;
        },
        set: function (values) {
            this.keyboardTypeData = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedService.prototype, "regionList", {
        get: function () {
            return this.regionsData;
        },
        set: function (values) {
            this.regionsData = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedService.prototype, "countryList", {
        get: function () {
            return this.countriesData;
        },
        set: function (values) {
            this.countriesData = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedService.prototype, "virtualLocationCountryList", {
        get: function () {
            return this.virtualLocationCountriesData;
        },
        set: function (values) {
            this.virtualLocationCountriesData = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedService.prototype, "stateList", {
        get: function () {
            return this.stateData;
        },
        set: function (values) {
            this.stateData = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedService.prototype, "cityList", {
        get: function () {
            return this.cityData;
        },
        set: function (values) {
            this.cityData = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedService.prototype, "businessCenterList", {
        get: function () {
            return this.businessCenterData;
        },
        set: function (values) {
            this.businessCenterData = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedService.prototype, "proctorGroupList", {
        get: function () {
            return this.groupData;
        },
        set: function (values) {
            this.groupData = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedService.prototype, "timeZoneList", {
        get: function () {
            return this.timeZoneData;
        },
        set: function (values) {
            this.timeZoneData = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedService.prototype, "officeList", {
        get: function () {
            return this.officeData;
        },
        set: function (data) {
            this.officeData = data;
        },
        enumerable: true,
        configurable: true
    });
    // call API to get User Profile
    SharedService.prototype.getUserProfile = function () {
        return this._httpClient.get(AppUrl.candidateProfile, "?userId=" + this.appGlobal.userId);
    };
    // call API to get Country List
    SharedService.prototype.searchCountries = function (urlParams) {
        return this._httpClient.get(AppUrl.searchCountries, urlParams);
    };
    // call API to get address List for exams
    SharedService.prototype.getExamAddressList = function (urlParams) {
        return this._httpClient.get(AppUrl.getExamAddressList, urlParams);
    };
    // call API to get a List of locations
    SharedService.prototype.getPublicLocations = function () {
        return this._http.get("/individualexamscheduler/services/public/v1/locations.json");
    };
    // call API to get Exams List
    SharedService.prototype.getEligibilities = function (urlParams) {
        return this._httpClient.get(AppUrl.getEligibilities, urlParams);
    };
    // to get address of a lat, long
    SharedService.prototype.getAddressOfLatLng = function (lat, lng) {
        var url = "http://maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + lng + "&sensor=true";
        return this._http.get(url);
    };
    // call API to upload Id
    SharedService.prototype.uploadId = function (formData) {
        formData.append('userId', this.appGlobal.userId);
        return this._httpClient.post(AppUrl.candidateUploadId, formData);
    };
    // call API to cancel exam
    SharedService.prototype.cancelExam = function (params) {
        params.userId = this.appGlobal.userId;
        return this._httpClient.post(AppUrl.cancelExam, params);
    };
    // call API to get Exams List
    SharedService.prototype.getTimeDiff = function (urlParams) {
        return this._httpClient.get(AppUrl.getTimeDiff, urlParams);
    };
    Object.defineProperty(SharedService.prototype, "adminData", {
        // get admin data
        get: function () {
            return this.adminFormData;
        },
        // set admin selected data
        set: function (values) {
            this.adminFormData = values;
        },
        enumerable: true,
        configurable: true
    });
    //Save, Update Exams
    SharedService.prototype.saveNewEntity = function (value, type) {
        var param = { type: type, code: value };
        return this._httpClient.post(AppUrl.addEntity, param);
    };
    /* Change status Active or Retire
     * @param identityId - This is Id of particular record
     * @param identityType - Type for which you have to chang status like Koala or Location or Admin
     * @parm  status -  What status you have to do
    */
    SharedService.prototype.changeStatus = function (identityId, identityType, status) {
        var param = { identityId: Number(identityId), identityType: identityType, status: status };
        return this._httpClient.post(AppUrl.changeStatus, param);
    };
    // Request Function to get data for search fields
    SharedService.prototype.getComboFieldsData = function (outputType, fn) {
        var params = "?outputType=" + outputType;
        this.requestDataForCombo(params).subscribe(function (response) {
            if (response.response) {
                var resp = { response: response.response.results };
                return fn(resp);
            }
        }, function (error) { });
    };
    SharedService.prototype.requestDataForCombo = function (urlParams) {
        return this._httpClient.get(AppUrl.requestDataForCombo, urlParams);
    };
    SharedService.prototype.loadCountryStateCityData = function () {
        var _this = this;
        if (!this.countryList) {
            this.getComboFieldsData(Enum.Country, function (response) {
                _this.countryList = response.response;
            });
        }
        if (!this.stateList) {
            this.getComboFieldsData(Enum.State, function (response) {
                _this.stateList = response.response;
            });
        }
        if (!this.cityList) {
            this.getComboFieldsData(Enum.City, function (response) {
                _this.cityList = response.response;
            });
        }
    };
    SharedService.prototype.getUsers = function (urlParams) {
        return this._httpClient.get(AppUrl.getUsers, urlParams);
    };
    /**
     * Used for Global admin, site admin and regional admin
     * @param params - query string params
     */
    SharedService.prototype.saveAdminDetail = function (params, roleType) {
        params.roleType = roleType;
        return this._httpClient.post(AppUrl.addUpdateAdmin, params);
    };
    /**
     *
     * @param params - required params
     * @param roleType - for which role you have to perform retire operations (Global admin, regional admin , site admin)
     */
    SharedService.prototype.retireActivateAdmin = function (params) {
        return this._httpClient.post(AppUrl.retireAdmin, params);
    };
    /**
     * service to download the uploaded document/pdf (png/jpeg/pdf)
     * @param params - required params
     */
    SharedService.prototype.downloadFile = function (params) {
        return this._httpClient.downloadFile(AppUrl.downloadApprovalId, params);
    };
    /**
     * service to download the csvs
     * @param params - required params
     */
    SharedService.prototype.downloadEligibilitiesCsv = function (params) {
        return this._httpClient.downloadFile(AppUrl.downloadEligibilities, params);
    };
    /**
     * service to download the csvs
     * @param params - required params
     */
    SharedService.prototype.downloadEligibilitiesForProctorSchedulingCsv = function (params) {
        return this._httpClient.downloadFile(AppUrl.downloadEligibilitiesForProctorScheduling, params);
    };
    /**
     * service to get Candidate/Admin notifications
     * @param params - required params
     */
    SharedService.prototype.getNotifications = function () {
        return this._httpClient.get(AppUrl.getNotification);
    };
    /**
     * service to update Candidate notification
     * @param params - required params
     */
    SharedService.prototype.updateNotificationStatus = function (params) {
        return this._httpClient.put(AppUrl.updateNotification, params);
    };
    /**
     * service to logout the user from back-end
     */
    SharedService.prototype.logoutUser = function () {
        return this._httpClient.delete(AppUrl.logoutUser);
    };
    /**
   * to read settings.json file a http request is send.
   * this. is done so that one can change the value in settings.json after build also, changed value will be updated
   */
    SharedService.prototype.getSettingsJSON = function () {
        return this._http.get(AppUrl.settings);
    };
    SharedService.prototype.getVersion = function () {
        var params = "?" + new Date().getTime();
        return this._http.get(AppUrl.version + params);
    };
    SharedService.prototype.getUserPermissions = function () {
        return this._httpClient.getPermissions();
    };
    return SharedService;
}());
export { SharedService };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Services/shared.service.ts.pre-build-optimizer.js